var _excluded = ["value", "children", "className", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';

class CheckboxListInput extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "onChange", e => {
      if (this.props.onChange) {
        var _e$target = e.target,
            checked = _e$target.checked,
            _value = _e$target.value;
        var currentSelection = (this.props.value || []).slice(0);

        if (checked) {
          currentSelection.push(_value);
        } else {
          var i = currentSelection.indexOf(_value);
          i > -1 && currentSelection.splice(i, 1); // eslint-disable-line no-unused-expressions
        }

        this.props.onChange(currentSelection);
      }
    });
  }

  render() {
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars -- This will go away when this is a function component */
    var _this$props = this.props,
        value = _this$props.value,
        children = _this$props.children,
        className = _this$props.className,
        onChange = _this$props.onChange,
        props = _objectWithoutProperties(_this$props, _excluded);

    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, React.Children.map(children, choice => /*#__PURE__*/React.isValidElement(choice) && /*#__PURE__*/React.cloneElement(choice, _objectSpread({
      type: 'checkbox',
      selected: value,
      onChange: this.onChange
    }, props))));
  }

}

_defineProperty(CheckboxListInput, "propTypes", {
  children: PropTypes.node,
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.array
});

CheckboxListInput.displayName = "CheckboxListInput";
export default CheckboxListInput;